<template>
	<div>
		<div class="introduce">
			<div class="introduce-title">公司简介</div>
			<div class="introduce-content">
				<div>为客户提供“互联网+”整体解决方案</div>
				<div>提供“互联网+”整体解决方案，集互联网产品研发、自媒体运营、文化传播、运营推广、商品销售、管理咨询为一体的互联网科技公司。总部位于重庆市，目前拥有员工60余人，拥有丰富的行业经验、客户案例和整合资源。拥有独立运营推广团队的微信平台服务商。</div>
			</div>
		</div>
		<!-- 我们的优势 -->
		<div class="advantage">
			<div class="advantage-title">我们的优势</div>
			<div class="advantage-tags">
				<div>数据可视化</div>
				<div>运营策划</div>
				<div>应用推广</div>
				<div>政务客户</div>
			</div>
			<div class="advantage-list">
				<div class="advantage-li">
					<img src="../../assets/icon/book.png" alt="">
					<h4>强大的技术支撑</h4>
					<div>Node，js，node，webkit，react，reactnative angularJs，PHP，H5等主流程序语言,始终紧跟软件前端技术,平台兼容性广泛</div>
				</div>
				<div class="advantage-li">
					<img src="../../assets/icon/file.png" alt="">
					<h4>专业的运营策划团队</h4>
					<div>运营策划，数据分析，托管服务，全面助力互联网营销</div>
				</div>
				<div class="advantage-li">
					<img src="../../assets/icon/earphone.png" alt="">
					<h4>完善的服务体系</h4>
					<div>整合重庆本地多渠道，多形式互联网资源</div>
				</div>
			</div>
		</div>
		<!-- 团队优势 -->
		<div class="team">
			<div class="team-title">团队优势</div>
			<div class="team-text">提供“互联网+”整体服务解决方案</div>
			<div class="team-tags">
				<div v-for="(item,index) in list" :key="index"><span>{{item.tag}}</span>{{item.text}}</div>
			</div>
		</div>
		<!-- 优质客户 -->
		<div class="address">
			<div class="client-title">
				<h3>公司地址</h3>
			</div>
			<div class="">
				<Map :height="height"></Map>
			</div>
		</div>
		<div class="contact">
			<div>详细地址：重庆市 渝北区 园博园 两江盛景 </div>
			<div>联系电话：18716389434(万先生)</div>
		</div>
	</div>
</template>

<script>
import Map from "../../components/map/index.vue"
	export default({
		data(){
			return{
				list:[{
					tag:'策略',
					text:'定制&输出'
				},{
					tag:'营销',
					text:'方案&策划'
				},{
					tag:'互动',
					text:'创意&表现'
				},{
					tag:'自媒体',
					text:'托管&运营'
				},{
					tag:'技术',
					text:'开发&执行'
				},{
					tag:'视觉',
					text:'设计&传达'
				},{
					tag:'资源',
					text:'整合&推广'
				},{
					tag:'大数据',
					text:'统计&分析'
				},],
				height:'15rem',
			}
		},
		components:{
			Map
		},
	})
</script>

<style lang="scss" scoped>
	.introduce{
		background: #FBFBFB;
		padding:4rem 2rem;
		.introduce-title{
			font-size: 1.8rem;
			font-weight: 600;
			color: #1D2129;
			line-height: 2.2rem;
			text-align: center;
		}
		.introduce-content{
			>div{
				font-size: 0.8rem;
				color: var(--main-color);
				line-height: 0.94rem;
				text-overflow: -o-ellipsis-lastline;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 3;
				-webkit-box-orient: vertical;      
				&:nth-child(1){
					margin-bottom:1.2rem;
					font-size: 1rem;
					line-height: 1.17rem;
					color: #1D2129;
					margin-top:2rem;
				}
			}
		}
	}
	.advantage{
		background:#fff;
		padding:4rem 2rem;
		.advantage-title{
			font-size: 1.8rem;
			font-weight: 600;
			color: #1D2129;
			line-height: 2.2rem;
			text-align: center;
		}
		.advantage-tags{
			display:flex;
			justify-content: center;
			margin-top:.8rem;
			font-size: 1rem;
			color: var(--main-color);
			line-height: 1.4rem;
			>div{
				margin-left:2.8rem;
				&:nth-child(1){
					margin-left:0;
				}
			}
		}
		.advantage-list{
				display:flex;
				// align-items: center;
				justify-content: space-between;
				margin-top:2.5rem;
				.advantage-li{
					display:flex;
					flex-direction: column;
					align-items: center;
					width:32%;
					box-sizing: border-box;
					padding:1.8rem 2.05rem .6rem;
					>img{
						width:2.4rem;
						height:2.4rem;
						vertical-align: top;
					}
					>h4{
						font-size: 1rem;
						color: #1D2129;
						line-height: 1.2rem;
						margin:1rem 0 0.63rem;
					}
					>div{
						font-size: 0.7rem;
						line-height: 1.2rem;
						color: var(--main-color);
						text-overflow: -o-ellipsis-lastline;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 4;
						-webkit-box-orient: vertical;
						text-align: center;
					}
				}
		}
	}
	.team{
		height:22.1rem;
		width:100%;
		background:url('../../assets/img/advantage-bg.png') no-repeat left top;
		background-size:100% 100%;
		background-color:#1790FF;
		box-sizing: border-box;
		padding:4rem 0;
		.team-title{
			font-size: 1.8rem;
			color: #FFFFFF;
			line-height: 2.2rem;
			font-weight: 600;
			text-align: center;
		}
		.team-text{
			font-size: 1rem;
			line-height: 1.4rem;
			color: #FFFFFF;
			margin-top:.8rem;
			text-align: center;
		}
		.team-tags{
			padding:0 4.55rem;
			margin-top:.9rem;
			display:flex;
			flex-wrap:wrap;
			>div{
				margin-top:1.6rem;
				width:24%;
				box-sizing: border-box;
				margin-right:.4rem;
				display:flex;
				justify-content: center;
				align-items: center;
				background: rgba(255,255,255,0.7);
				border-radius: 2.3rem 2.3rem 2.3rem 2.3rem;
				border: 0.05rem solid #1790FF;
				padding:.7rem 0;
				font-size: 1rem;
				color: #1D2129;
				line-height: 1.4rem;
				>span{
					padding:.2rem .65rem;
					border-radius: 2.7rem 2.7rem 2.7rem 2.7rem;
					background: #1790FF;
					color: #FFFFFF;
					margin-right:.5rem;
				}
			}
		}
	}
	.address{
		background: #FBFBFB;
		.client-title{
			padding:4rem 2.8rem 2rem;
			text-align: center;
			>h3{
				position: relative;
				font-weight: 400;
				color: #1D2129;
				line-height: 1.3rem;
				font-size: 1.3rem;
				&::before{
					content:'';
					width:20rem;
					height:2px;
					position: absolute;
					left:0;
					top:50%;
					transform: translateY(-50%);
					background:linear-gradient(-45deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0));
				}
				&::after{
					content:'';
					width:20rem;
					height:2px;
					position: absolute;
					right:0;
					top:50%;
					transform: translateY(-50%);
					background:linear-gradient(45deg, rgba(0, 0, 0, .2), rgba(0, 0, 0, 0));
				}
			}
		}
		.client-list{
			display:flex;
			flex-wrap: wrap;
			align-items: center;
			padding:.8rem 2rem 0;
			>img{
				width:18%;
				height:2.7rem;
				margin-right:1.2rem;
				&:nth-child(5n){
					margin-right:0;
				}
			}
		}
	}
	.contact{
		height:9rem;
		background:url('../../assets/img/contact-bg.png') no-repeat left top;
		background-size:100% 100%;
		display:flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		>div{
			font-size: 1.3rem;
			color: #FFFFFF;
			line-height: 1.3rem;
			&:nth-child(2){
				margin-top:1.2rem;
			}
		}
	}
</style>
